// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ipt[data-v-28cf78c9] {\n  width: 42px;\n  height: 24px;\n  background: #FFFFFF;\n  border: 1px solid #D9D9D9;\n  border-radius: 4px;\n  text-align: center;\n  font-size: 14px;\n  color: #666;\n  margin: 0 4px;\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
